import { callApi as CallApi, getDomainsFromEmails, getNestedProperty, isDomainValidService, SenderModel, SendersFactory, TBrand, TCallApi, TDObject, TGenericListReturn, TIsDomainVerified } from "cakemail-ui-components-v2"
import { TErrorHandlerResponse } from "../types/utils"
import { TGetSenderDomainsInfo } from "../types/api"

export const APP_URL = window.location.origin
export const GATEWAY_PROXY = APP_URL + "/api"

export function callApi({ url, delay, tries, fetchOptions, query, useImpersonationTree }: TCallApi) {
    //@ts-ignore
    return CallApi({ url, delay, tries, fetchOptions, query, useImpersonationTree, errorHandler })
}


export function errorHandler({ errorResponse }: { errorResponse: any }): TErrorHandlerResponse {
    let msg: string | undefined = undefined
    let code: number | undefined = undefined
    const details = errorResponse.body?.detail || errorResponse.detail || errorResponse.body?.error?.detail

    const returnMessage: TErrorHandlerResponse = { msg: msg, code: code, data: errorResponse.body, response: errorResponse.response }

    //Api generated codes
    if (details?.[0]?.code) {
        returnMessage.code = code = details[0].code
        switch (code) {
            case 1007:
                msg = "error-code-1007"
                break
            case 8015:
                msg = "error-code-8015"
            default:
                break
        }
    } else {
        //Exact message
        const message = typeof details === "string" ? details : details?.[0]?.msg || errorResponse.response?.statusText
        code = errorResponse.response.status
        switch (message) {
            case "User id not found":
                msg = "error-impersonate-user-not-found"
                break
            default:
                //Partial message
                break
        }

    }

    return { msg: msg, code: code, data: errorResponse.body, response: errorResponse.response }
}


//Current feature flags
export enum EFeatureFlags {
    organisation = "multiAccountEnabled",
    mfa = "mfaEnabled",
    emailAPI = "transactionalEnabled",
    stripePortal = "stripe_portal_access",
    yaplaCMS = "client_config.yaplaCms.calendarEventsEnabled",

    verisoul = "client_config.verisoul.enabled",
    verisoulDryRun = "client_config.verisoul.dryrun",
    indiegraf = "client_config.indiegrafIntegration.enabled",
    intercomClassname = "client_config.intercom_classname",

    assetManagement = "assetManagementEnabled"
};

export function hasFeatureFlag({ flag, onByDefault = false, resellerBrand, userBrand }: { flag: EFeatureFlags, onByDefault?: boolean, resellerBrand: TBrand, userBrand?: TBrand }) {

    let nestedFlag = flag.split(".")
    let resellerEnabled = undefined
    let accountEnabled = undefined

    if (nestedFlag?.length > 1) {
        resellerEnabled = getNestedProperty(resellerEnabled, flag)
        if (userBrand) {
            accountEnabled = getNestedProperty(accountEnabled, flag)
        }
    } else {
        resellerEnabled = resellerBrand?.config?.[flag]
        if (userBrand) {
            accountEnabled = userBrand?.config?.[flag]
        }

    }

    if (onByDefault) {
        return accountEnabled !== false || resellerEnabled !== false
    }
    return accountEnabled || resellerEnabled
}


export async function getSenderDomainsInfo(accountId: number): Promise<TGetSenderDomainsInfo> {
    return SendersFactory.list({ page: 1, perPage: 200 }).then((senders) => {
        const domainList = getDomainsFromEmails(senders.data)
        const senderDomainsPromise: Promise<any>[] = []
        const total = senders.data.length
        let confirmed = 0
        senders.data.forEach((sender) => {
            if (sender.confirmed)
                confirmed++
        })
        domainList.forEach((email) => {
            senderDomainsPromise.push(new Promise((resolve, reject) => {
                isDomainValidService({ domain: email }).then((domainData) => {
                    resolve({ [email]: domainData })
                }).catch(() => {
                    resolve({ [email]: { verified: false } })
                })
            }))
        })

        if (domainList.length === 0) {
            return {
                senderDomains: {},
                created: total,
                confirmed
            }
        }

        return Promise.allSettled(senderDomainsPromise).then((results: PromiseSettledResult<{ [domain: string]: TIsDomainVerified }>[]) => {
            let partialResults: any = {}
            results.forEach((result) => {
                if (result.status === "fulfilled") {
                    if (!partialResults) partialResults = {}
                    const domain: string = Object.keys(result.value)?.[0]
                    const domainDetails: any = result.value[domain].details

                    const domainData: any = {
                        verified: result.value[domain].verified,
                        blocked: domainDetails.dmarc.details.verdict < 0
                    }

                    partialResults[domain] = domainData
                }
            })
            return {
                senderDomains: partialResults,
                created: total,
                confirmed
            }
        })
    }).catch(() => {
        return {
            senderDomains: {},
            created: 0,
            confirmed: 0
        }
    })
}